export const BANNER_NAME = 'StorageEnforcementBanner';
export const BANNER_HEIGHT = 8 * 7;
